import { Injectable } from '@angular/core';
import { SystemAdmin } from './admin.model';
import { Observable } from 'rxjs';
import { RequestResult, TableData } from '../shared/shared.model';
import { API_URL } from '../app.constants';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SystemAdminService {

  constructor(private http: HttpClient) { }

  list(page: number, pageSize: number): Observable<TableData<SystemAdmin>> {
    return this.http.get<TableData<SystemAdmin>>(`${API_URL}/SystemAdmins`, {
      params: {
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<SystemAdmin>) => {
        res.page--;

        return res;
      })
    );
  }
  add(app: SystemAdmin): Observable<number> {
    return this.http.post<number>(`${API_URL}/SystemAdmins`, app);
  }
  delete(id: string): Observable<RequestResult> {
    return this.http.delete<RequestResult>(`${API_URL}/SystemAdmins/${id}`);
  }
  changeStatus(id: string, active: boolean): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/SystemAdmins/status`, {adminUsername: id, active});
  }
  checkSystemAdminExistence(name: string): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/SystemAdmins/exists/${encodeURIComponent(name)}`);
  }
  showAdminMenu(): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/SystemAdmins/showMenu`);
  }
  showAuditMenu(): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/SystemAdmins/showAuditMenu`);
  }
  showSidMenu(): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/SystemAdmins/showSidMenu`);
  }
}
